import { Button, Theme, useMediaQuery, useTheme } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { useNavigate } from 'react-router-dom';
import { LinkTypeEnum } from '../../store/config/enums';
import { Link } from '../../store/config/types';
import { theme } from '../../styles/theme';
import { ScreenTitle } from '../ScreenTitle';
import LinkActions from './LinkActions';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    screenTitle: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
      marginBottom: '2rem',
      '& button': {
        [theme.breakpoints.down('md')]: {
          padding: '0.4375rem 0.75rem',
        },
      },
      [theme.breakpoints.down('md')]: {
        marginBottom: '1.5rem',
      },
    },
  }),
);

interface NewLinkHeaderProps {
  setClickedCopy: React.Dispatch<React.SetStateAction<boolean | null>>;
  linkType: LinkTypeEnum;
  link: Link;
  updatingLink: boolean;
  creatingLink: boolean;
  paymentMethodsIds: number[];
  clickedCopy: boolean | null;
}

function NewLinkHeader({
  linkType,
  link,
  setClickedCopy,
  clickedCopy,
  updatingLink,
  creatingLink,
  paymentMethodsIds,
}: NewLinkHeaderProps) {
  const classes = useStyles(useTheme());
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isPermantent = linkType === LinkTypeEnum.PERMANENT;
  const screenTitle = link
    ? 'Editar Link de pago'
    : isPermantent
    ? 'Nuevo link multiuso'
    : 'Nuevo link de 1 uso';

  return (
    <div className={classes.screenTitle}>
      <ScreenTitle title={screenTitle}>
        {!isMobile && (
          <LinkActions
            setClickedCopy={setClickedCopy}
            link={link}
            creatingLink={creatingLink}
            updatingLink={updatingLink}
            clickedCopy={clickedCopy}
            paymentMethodsIds={paymentMethodsIds}
          />
        )}
      </ScreenTitle>
      {isMobile && (
        <Button variant="outlined" color="secondary" onClick={() => navigate(-1)}>
          Volver
        </Button>
      )}
    </div>
  );
}

export default NewLinkHeader;
